import {Modal} from 'react-bootstrap-v5'
import axios from 'axios'
import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {ButtonSubmit, Select, TextInput, TextInputMask} from '../../Form'
import {Formik} from 'formik'
import {CEPMask} from '../../masks'
import {
    updateAddressInitialValues,
    UpdateCompanyAddressRequest,
    updateAddressValidationSchema,
    CompanyModel,
} from '../models'

interface Props {
    onClose: () => void
    isOpen: boolean
    company: CompanyModel
    onUpdate: () => void
}

export default function UpdateCompanyAddressModal({company, onClose, isOpen, onUpdate}: Props) {
    const [loading, setLoading] = useState(false)
    const [initialValues, setInitialValues] = useState<UpdateCompanyAddressRequest>(
        updateAddressInitialValues
    )

    useEffect(() => {
        setInitialValues({
            ds_zipcode: company.address?.ds_zipcode ?? '',
            ds_street: company.address?.ds_street ?? '',
            ds_number: company.address?.ds_number ?? '',
            ds_complement: company.address?.ds_complement ?? '',
            ds_neighborhood: company.address?.ds_neighborhood ?? '',
            ds_city: company.address?.ds_city ?? '',
            ds_state: company.address?.ds_state ?? '',
        })
    }, [company])

    async function createUser(requestData: any) {
        try {
            setLoading(true)
            const {data} = await axios.put(`/company/update/address`, requestData)
            toast.success(data.message)
            onUpdate()
            onClose()
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal
            onHide={() => onClose()}
            show={isOpen}
            aria-labelledby='contained-modal-title-venter'
            size='xl'
            centered
        >
            <Modal.Header>
                <Modal.Title id='contained-modal-title-center'>Editar informações</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Formik
                    initialValues={initialValues}
                    validationSchema={updateAddressValidationSchema}
                    onSubmit={(values) => {
                        createUser(values)
                    }}
                >
                    {(props) => {
                        const {handleSubmit} = props
                        return (
                            <form onSubmit={handleSubmit} noValidate>
                                <div className='row'>
                                    <div className='col-lg-3 col-12 mb-5'>
                                        <TextInputMask
                                            name='ds_zipcode'
                                            label='CEP'
                                            placeholder='Entre com o CEP'
                                            mask={CEPMask}
                                            required
                                        />
                                    </div>
                                    <div className='col-lg-5 col-12 mb-5'>
                                        <TextInput
                                            name='ds_street'
                                            label='Logradouro'
                                            placeholder='Entre com o logradouro'
                                            required
                                        />
                                    </div>

                                    <div className='col-lg-2 col-12 mb-5'>
                                        <TextInput
                                            name='ds_number'
                                            label='Número'
                                            placeholder='Entre com o número'
                                            required
                                        />
                                    </div>
                                    <div className='col-lg-2 col-12 mb-5'>
                                        <TextInput
                                            name='ds_complement'
                                            label='Complemento'
                                            placeholder='Entre com o complemento'
                                        />
                                    </div>
                                    <div className='col-lg-3 col-12'>
                                        <TextInput
                                            name='ds_neighborhood'
                                            label='Bairro'
                                            required
                                            placeholder='Entre com o bairro'
                                        />
                                    </div>
                                    <div className='col-lg-3 col-12'>
                                        <TextInput
                                            name='ds_city'
                                            label='Cidade'
                                            required
                                            placeholder='Entre com a cidade'
                                        />
                                    </div>
                                    <div className='col-lg-3 col-12 mb-5'>
                                        <Select label='Estado' name='ds_state' required>
                                            <option value='AC'>AC</option>
                                            <option value='AL'>AL</option>
                                            <option value='AP'>AP</option>
                                            <option value='AM'>AM</option>
                                            <option value='BA'>BA</option>
                                            <option value='CE'>CE</option>
                                            <option value='DF'>DF</option>
                                            <option value='ES'>ES</option>
                                            <option value='GO'>GO</option>
                                            <option value='MA'>MA</option>
                                            <option value='MT'>MT</option>
                                            <option value='MS'>MS</option>
                                            <option value='MG'>MG</option>
                                            <option value='PA'>PA</option>
                                            <option value='PB'>PB</option>
                                            <option value='PR'>PR</option>
                                            <option value='PE'>PE</option>
                                            <option value='PI'>PI</option>
                                            <option value='RJ'>RJ</option>
                                            <option value='RN'>RN</option>
                                            <option value='RS'>RS</option>
                                            <option value='RO'>RO</option>
                                            <option value='RR'>RR</option>
                                            <option value='SC'>SC</option>
                                            <option value='SP'>SP</option>
                                            <option value='SE'>SE</option>
                                            <option value='TO'>TO</option>
                                        </Select>
                                    </div>
                                </div>
                                <ButtonSubmit
                                    label='Atualizar'
                                    loading={loading}
                                    onCancel={() => onClose()}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}
